export function removeEmptyConditions(filter: any) {
  if (!filter) {
    return filter;
  }
  const audiences = filter.conditions?.[0]?.conditions?.filter(
    isBaseConditionNotEmpty
  );
  const conditions = filter.conditions?.[1]?.conditions
    ?.map((combined: any) => {
      const bases = combined.conditions.filter(isBaseConditionNotEmpty);
      return {
        ...combined,
        conditions: bases,
      };
    })
    .filter(isCombinedConditionNotEmpty);

  return {
    type: "combined",
    conditionType: "AND",
    conditions: [
      {
        type: "combined",
        conditionType: "AND",
        conditions: audiences,
      },
      {
        type: "combined",
        conditionType: "OR",
        conditions: conditions,
      },
    ],
  };
}

function isBaseConditionNotEmpty(base: any) {
  if (!base.attributeType || !base.attributeName || !base.criteria) {
    return false;
  }
  if (
    base.attributeType === "AUDIENCE" &&
    base.attributeName === "Audience" &&
    base.criteria === "IN" &&
    (base.value?.value?.length || 0) === 0
  ) {
    return false;
  }

  return true;
}

function isCombinedConditionNotEmpty(combined: any) {
  return combined?.conditions?.length > 0;
}
